"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.inRange = void 0;
var ramda_1 = require("ramda");
function min(m) {
    return function (value) { return value < m ? m : value; };
}
function max(m) {
    return function (value) { return value > m ? m : value; };
}
/**
 * Принимает min и max значения, отдает функцию принимающую два числа,
 * результатом выполнения этой функции является передаваемое значение если оно в диапазоне, или ближайшую границу иначе.
 */
function inRange(minimal, maximal) {
    return (0, ramda_1.pipe)(min(minimal), max(maximal));
}
exports.inRange = inRange;
//# sourceMappingURL=inRange.js.map